import { POSTransaction, POSPaymentDetailRecord, POSPaymentMethod } from '../types/pos';

const CACHE_KEY = 'pos_split_payments_v1';

function readCache(): Record<string, POSPaymentDetailRecord[]> {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, POSPaymentDetailRecord[]>;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function saveSplitPaymentCache(txnId: number, details: POSPaymentDetailRecord[]): void {
  if (!details.length) return;
  try {
    const map = readCache();
    map[String(txnId)] = details;
    localStorage.setItem(CACHE_KEY, JSON.stringify(map));
  } catch {
    // ignore quota / private mode
  }
}

export function mergeSplitPaymentCache(txn: POSTransaction): POSTransaction {
  if (txn.payment_details && txn.payment_details.length > 1) {
    return txn;
  }
  try {
    const cached = readCache()[String(txn.id)];
    if (!Array.isArray(cached) || cached.length < 2) {
      return txn;
    }
    return {
      ...txn,
      payment_method: POSPaymentMethod.SPLIT,
      payment_details: cached.map((line) => ({
        payment_method: String(line.payment_method),
        amount: Number(line.amount) || 0,
        reference_number: line.reference_number || undefined,
      })),
    };
  } catch {
    return txn;
  }
}
